import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import { bool, func, string } from 'prop-types';

import { VALIDATE_CHANGE_PRIMARY_EMAIL } from 'constants/reduxForms';
import { actionCreators as authActions } from 'redux/authHandlers';

import ValidateEmail from './layout';
import styles from './styles';

class ValidateEmailContainer extends PureComponent {
  handleResendCode = () => this.props.dispatch(authActions.changePrimaryEmail(this.props.newEmail));

  render() {
    return (
      <form onSubmit={this.props.handleSubmit} style={styles.container}>
        <ValidateEmail
          loading={this.props.loading}
          newEmail={this.props.newEmail}
          onResendCode={this.handleResendCode}
        />
      </form>
    );
  }
}

ValidateEmailContainer.propTypes = {
  handleSubmit: func,
  loading: bool,
  newEmail: string
};

export default reduxForm({ form: VALIDATE_CHANGE_PRIMARY_EMAIL })(ValidateEmailContainer);
